import React from 'react'
import { calculateRekomendasiProcessingDays, hasValidStatus } from '../../../../services/helpers';
import { Chip } from '@nextui-org/react';
import TipeSurat from '../../../../enums/tipeSurat';

export default function TimeProcessBadge({rowApplicationStatus, rowApplicationType}) {
    const lamaProses = calculateRekomendasiProcessingDays(rowApplicationStatus);
        if (lamaProses < 45 && (hasValidStatus([rowApplicationType], [TipeSurat.BARU, TipeSurat.PENAMBAHAN_KENDARAAN])) ) {
            return <Chip color="success" variant="flat" size="sm">{lamaProses} Hari</Chip>;
        }
        else if (lamaProses < 14 && (hasValidStatus([rowApplicationType], [TipeSurat.PENAMBAHAN_JENIS_B3, TipeSurat.PERPANJANGAN]))){
            return <Chip color="success" variant="flat" size="sm">{lamaProses} Hari</Chip>;
        }
        else if (!hasValidStatus([rowApplicationType], [TipeSurat.PENAMBAHAN_JENIS_B3, TipeSurat.PERPANJANGAN, TipeSurat.BARU, TipeSurat.PENAMBAHAN_KENDARAAN])) {
            return <Chip color="success" variant="flat" size="sm">{lamaProses} Hari</Chip>;
        }
        else {
            return <Chip color="danger" variant="flat" size="sm">{lamaProses} Hari</Chip>;
        }    
}
